import React from 'react'
import PropTypes from 'prop-types';
import { IntCreator, Icons } from '@leverege/api-attributes';
import { ValueCard } from '~/views';

export default class IntViewer extends React.Component {

  static TYPE = IntCreator.typeName();

  static propTypes = {
    device : PropTypes.object,
    attribute : PropTypes.object,
    blueprint : PropTypes.object,
    name : PropTypes.string
  }

  render() {
    const { attribute : attr, name, onClick, editable } = this.props
    if ( attr == null ) {
      return <div />
    }

    let val = null // '---'
    if ( typeof this.props.value === 'number' ) { 
      val = this.props.value
    } else if ( typeof this.props.value === 'string' ) {
      const n = parseInt( this.props.value )
      if ( !isNaN( n ) ) {
        val = n
      }
    }
    const icon = Icons.getIcon( attr )
    return (
      <ValueCard editable={editable} name={name || attr.name} value={val} icon={icon} onClick={onClick} />
    )
  }
}
